export default {
    step: 1,
    currentComponent: "negociar-divida",
    dividas: [],
    contractNegotiable:[],
    contractNegotiableOptions:[],
    parcelamentSelected:null,
    agreementResume:null,
    acordo: {}
}